module.exports = __webpack_public_path__ + "img/scroll-top.651f9c6d.svg";